"use strict";

let moduleName = 'map',
    scriptLoader = require('scriptjs');

module.exports = function () {
    $('.js-map').each(function () {
        if ($.data(this, moduleName + '-init')) return;
        $.data(this, moduleName + '-init', true);

        let $map = $(this),
            zoom = $map.data('zoom'),
            center = $map.data('center').split(',').map(function (item) {return +item}),
            point = $map.data('point').split(',').map(function (item) {return +item}),
            icon = $map.data('icon'),
            iconSize = $map.data('icon-size').split(',').map(function (item) {return +item}),
            hasPoint = icon.length && iconSize.length === 2;

        if (center.length === 2 && zoom) {
            scriptLoader('https://api-maps.yandex.ru/2.1/?lang=ru_RU', function () {
                ymaps.ready(function () {
                    let map = new ymaps.Map($map[0], {
                        center : center,
                        zoom : zoom,
                        controls : ['geolocationControl', 'fullscreenControl', 'zoomControl']
                    });

                    map.behaviors.disable('scrollZoom');

                    if (point.length === 2) {
                        map.geoObjects.add(new ymaps.Placemark(point, {}, (hasPoint ? {
                            iconLayout : "default#imageWithContent",
                            iconImageHref : icon,
                            iconImageSize : iconSize,
                            iconImageOffset : [-iconSize[0] / 2, -iconSize[1]],
                            iconContentOffset : [0, 0]
                        } : {})));
                    }
                });
            });
        }
    });
};




// WEBPACK FOOTER //
// ./src/js/modules/mapInit.js